/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class DeactivateAccountResponse {
  /**
  * Whether the account was deactivated
  */
  'deactivated': boolean;
  /**
  * Remaining credits in whole units (only set if deactivated is false)
  */
  'remainingCredits'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "deactivated",
      "baseName": "deactivated",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "remainingCredits",
      "baseName": "remainingCredits",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return DeactivateAccountResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

